/* eslint-disable array-callback-return */

export const parseFlatMovingDates = (type, movingDates) => {
  let flatMovingDates = {
    estimatedPackStart: null,
    estimatedPackEnd: null,
    actualPackStart: null,
    actualPackEnd: null,
    estimatedLoadStart: null,
    estimatedLoadEnd: null,
    actualLoadStart: null,
    actualLoadEnd: null,
    estimatedDeliveryStart: null,
    estimatedDeliveryEnd: null,
    actualDeliveryStart: null,
    actualDeliveryEnd: null,
    estimatedCarLoadingStart: null,
    estimatedCarLoadingEnd: null,
    actualCarLoadingStart: null,
    actualCarLoadingEnd: null,
    estimatedCarDeliveryStart: null,
    estimatedCarDeliveryEnd: null,
    actualCarDeliveryStart: null,
    actualCarDeliveryEnd: null,
    estimatedStorageStart: null,
    estimatedStorageEnd: null,
    actualStorageStart: null,
    actualStorageEnd: null,
    estimatedStorageDays: null,
    actualStorageDays: null,
    packLoadCallComplete: false,
    packLoadDeliveryCallComplete: false
  };

  let typeGuid = 'f63911ff-d8c4-4e3f-90b4-b841bad9c5a6';
  if (type === 2) {
    typeGuid = '8e046c0f-3d92-4080-b822-855a850e6206';
  } else if (type === 3) {
    typeGuid = '8e1e30d9-5a3b-45eb-8293-052c535cc565';
  } else if (type === 4) {
    typeGuid = 'e5243500-767b-4187-bc9c-4de7ed68db77';
  }

  const movingDatesSection = movingDates.find(md => md.info.hhgMovingDatesSectionId === typeGuid);

  flatMovingDates.estimatedStorageDays = movingDatesSection ? movingDatesSection.info.estimatedStorageDays : null;
  flatMovingDates.actualStorageDays = movingDatesSection ? movingDatesSection.info.actualStorageDays : null;
  flatMovingDates.packLoadCallComplete =
    movingDatesSection && movingDatesSection.info?.isCallComplete ? movingDatesSection.info.isCallComplete : false;
  flatMovingDates.packLoadDeliveryCallComplete =
    movingDatesSection && movingDatesSection.info?.isDeliveryCallComplete ? movingDatesSection.info.isDeliveryCallComplete : false;

  movingDatesSection.dates.map(date => {
    if (date.hhgMovingDatesCategoryId === 'd2ef6c97-344a-44c8-9db7-e07ae5f1ef3f') {
      flatMovingDates.estimatedPackStart = date.estimatedStartDate;
      flatMovingDates.estimatedPackEnd = date.estimatedEndDate;
      flatMovingDates.actualPackStart = date.actualStartDate;
      flatMovingDates.actualPackEnd = date.actualEndDate;
      flatMovingDates.packCallComplete = date.isCallComplete;
      flatMovingDates.packDeliveryCallComplete = date.isDeliveryCallComplete;
    } else if (date.hhgMovingDatesCategoryId === 'c656bae4-8baa-4e94-8d39-c0b7ec5015cb') {
      flatMovingDates.estimatedLoadStart = date.estimatedStartDate;
      flatMovingDates.estimatedLoadEnd = date.estimatedEndDate;
      flatMovingDates.actualLoadStart = date.actualStartDate;
      flatMovingDates.actualLoadEnd = date.actualEndDate;
      flatMovingDates.loadCallComplete = date.isCallComplete;
      flatMovingDates.loadDeliveryCallComplete = date.isDeliveryCallComplete;
    } else if (date.hhgMovingDatesCategoryId === '8f41c58a-5e76-4033-96e4-5a8b4dcb2364') {
      flatMovingDates.estimatedDeliveryStart = date.estimatedStartDate;
      flatMovingDates.estimatedDeliveryEnd = date.estimatedEndDate;
      flatMovingDates.actualDeliveryStart = date.actualStartDate;
      flatMovingDates.actualDeliveryEnd = date.actualEndDate;
    } else if (date.hhgMovingDatesCategoryId === 'aa7b1a02-ea88-4599-861d-993b673ab2df') {
      flatMovingDates.estimatedCarLoadingStart = date.estimatedStartDate;
      flatMovingDates.estimatedCarLoadingEnd = date.estimatedEndDate;
      flatMovingDates.actualCarLoadingStart = date.actualStartDate;
      flatMovingDates.actualCarLoadingEnd = date.actualEndDate;
    } else if (date.hhgMovingDatesCategoryId === 'd7772ae7-8ebc-4580-8ffd-8849e85aa43a') {
      flatMovingDates.estimatedCarDeliveryStart = date.estimatedStartDate;
      flatMovingDates.estimatedCarDeliveryEnd = date.estimatedEndDate;
      flatMovingDates.actualCarDeliveryStart = date.actualStartDate;
      flatMovingDates.actualCarDeliveryEnd = date.actualEndDate;
    } else if (date.hhgMovingDatesCategoryId === '6517f1c0-de3c-4d5a-a642-0245ac6f5ae2') {
      flatMovingDates.estimatedStorageStart = date.estimatedStartDate;
      flatMovingDates.estimatedStorageEnd = date.estimatedEndDate;
      flatMovingDates.actualStorageStart = date.actualStartDate;
      flatMovingDates.actualStorageEnd = date.actualEndDate;
    }
  });

  return flatMovingDates;
};

const safeDate = date => {
  if (!date || date === '' || date === undefined) return null;
  return date;
};

export const getMappedMovingDates = (type, movingDates, flatMovingDates) => {
  let typeGuid = 'f63911ff-d8c4-4e3f-90b4-b841bad9c5a6';
  if (type === 2) {
    typeGuid = '8e046c0f-3d92-4080-b822-855a850e6206';
  } else if (type === 3) {
    typeGuid = '8e1e30d9-5a3b-45eb-8293-052c535cc565';
  } else if (type === 4) {
    typeGuid = 'e5243500-767b-4187-bc9c-4de7ed68db77';
  }

  const movingDatesSectionIndex = movingDates.findIndex(md => md.info.hhgMovingDatesSectionId === typeGuid);
  let movingDatesSection = movingDates.find(md => md.info.hhgMovingDatesSectionId === typeGuid);

  movingDatesSection.info.estimatedStorageDays = flatMovingDates.estimatedStorageDays;
  movingDatesSection.info.actualStorageDays = flatMovingDates.actualStorageDays;
  movingDatesSection.info.isCallComplete = flatMovingDates.packLoadCallComplete;
  movingDatesSection.info.isDeliveryCallComplete = flatMovingDates.packLoadDeliveryCallComplete;

  let packDates = movingDatesSection.dates.find(d => d.hhgMovingDatesCategoryId === 'd2ef6c97-344a-44c8-9db7-e07ae5f1ef3f');
  if (packDates) {
    const packDatesIndex = movingDatesSection.dates.find(d => d.hhgMovingDatesCategoryId === 'd2ef6c97-344a-44c8-9db7-e07ae5f1ef3f');
    packDates.estimatedStartDate = safeDate(flatMovingDates.estimatedPackStart);
    packDates.estimatedEndDate = safeDate(flatMovingDates.estimatedPackEnd);
    packDates.actualStartDate = safeDate(flatMovingDates.actualPackStart);
    packDates.actualEndDate = safeDate(flatMovingDates.actualPackEnd);
    packDates.isCallComplete = flatMovingDates.packCallComplete;
    packDates.isDeliveryCallComplete = flatMovingDates.packDeliveryCallComplete;
    movingDatesSection.dates[packDatesIndex] = packDates;
  } else {
    movingDatesSection.dates.push({
      hhgMovingDatesId: movingDatesSection.info.hhgMovingDateId,
      hhgMovingDatesCategoryId: 'd2ef6c97-344a-44c8-9db7-e07ae5f1ef3f',
      estimatedStartDate: safeDate(flatMovingDates.estimatedPackStart),
      estimatedEndDate: safeDate(flatMovingDates.estimatedPackEnd),
      actualStartDate: safeDate(flatMovingDates.actualPackStart),
      actualEndDate: safeDate(flatMovingDates.actualPackEnd)
    });
  }

  let loadDates = movingDatesSection.dates.find(d => d.hhgMovingDatesCategoryId === 'c656bae4-8baa-4e94-8d39-c0b7ec5015cb');
  if (loadDates) {
    const loadDatesIndex = movingDatesSection.dates.find(d => d.hhgMovingDatesCategoryId === 'c656bae4-8baa-4e94-8d39-c0b7ec5015cb');
    loadDates.estimatedStartDate = safeDate(flatMovingDates.estimatedLoadStart);
    loadDates.estimatedEndDate = safeDate(flatMovingDates.estimatedLoadEnd);
    loadDates.actualStartDate = safeDate(flatMovingDates.actualLoadStart);
    loadDates.actualEndDate = safeDate(flatMovingDates.actualLoadEnd);
    loadDates.isCallComplete = flatMovingDates.loadCallComplete;
    loadDates.isDeliveryCallComplete = flatMovingDates.loadDeliveryCallComplete;
    movingDatesSection.dates[loadDatesIndex] = loadDates;
  } else {
    movingDatesSection.dates.push({
      hhgMovingDatesId: movingDatesSection.info.hhgMovingDateId,
      hhgMovingDatesCategoryId: 'c656bae4-8baa-4e94-8d39-c0b7ec5015cb',
      estimatedStartDate: safeDate(flatMovingDates.estimatedLoadStart),
      estimatedEndDate: safeDate(flatMovingDates.estimatedLoadEnd),
      actualStartDate: safeDate(flatMovingDates.actualLoadStart),
      actualEndDate: safeDate(flatMovingDates.actualLoadEnd)
    });
  }

  let deliveryDates = movingDatesSection.dates.find(d => d.hhgMovingDatesCategoryId === '8f41c58a-5e76-4033-96e4-5a8b4dcb2364');
  if (deliveryDates) {
    const deliveryDatesIndex = movingDatesSection.dates.find(d => d.hhgMovingDatesCategoryId === '8f41c58a-5e76-4033-96e4-5a8b4dcb2364');
    deliveryDates.estimatedStartDate = safeDate(flatMovingDates.estimatedDeliveryStart);
    deliveryDates.estimatedEndDate = safeDate(flatMovingDates.estimatedDeliveryEnd);
    deliveryDates.actualStartDate = safeDate(flatMovingDates.actualDeliveryStart);
    deliveryDates.actualEndDate = safeDate(flatMovingDates.actualDeliveryEnd);
    movingDatesSection.dates[deliveryDatesIndex] = deliveryDates;
  } else {
    movingDatesSection.dates.push({
      hhgMovingDatesId: movingDatesSection.info.hhgMovingDateId,
      hhgMovingDatesCategoryId: '8f41c58a-5e76-4033-96e4-5a8b4dcb2364',
      estimatedStartDate: safeDate(flatMovingDates.estimatedDeliveryStart),
      estimatedEndDate: safeDate(flatMovingDates.estimatedDeliveryEnd),
      actualStartDate: safeDate(flatMovingDates.actualDeliveryStart),
      actualEndDate: safeDate(flatMovingDates.actualDeliveryEnd)
    });
  }

  let carLoadingDates = movingDatesSection.dates.find(d => d.hhgMovingDatesCategoryId === 'aa7b1a02-ea88-4599-861d-993b673ab2df');
  if (carLoadingDates) {
    const carLoadingDatesIndex = movingDatesSection.dates.find(d => d.hhgMovingDatesCategoryId === 'aa7b1a02-ea88-4599-861d-993b673ab2df');
    carLoadingDates.estimatedStartDate = safeDate(flatMovingDates.estimatedCarLoadingStart);
    carLoadingDates.estimatedEndDate = safeDate(flatMovingDates.estimatedCarLoadingEnd);
    carLoadingDates.actualStartDate = safeDate(flatMovingDates.actualCarLoadingStart);
    carLoadingDates.actualEndDate = safeDate(flatMovingDates.actualCarLoadingEnd);
    movingDatesSection.dates[carLoadingDatesIndex] = carLoadingDates;
  } else {
    movingDatesSection.dates.push({
      hhgMovingDatesId: movingDatesSection.info.hhgMovingDateId,
      hhgMovingDatesCategoryId: 'aa7b1a02-ea88-4599-861d-993b673ab2df',
      estimatedStartDate: safeDate(flatMovingDates.estimatedCarLoadingStart),
      estimatedEndDate: safeDate(flatMovingDates.estimatedCarLoadingEnd),
      actualStartDate: safeDate(flatMovingDates.actualCarLoadingStart),
      actualEndDate: safeDate(flatMovingDates.actualCarLoadingEnd)
    });
  }

  let carDeliveryDates = movingDatesSection.dates.find(d => d.hhgMovingDatesCategoryId === 'd7772ae7-8ebc-4580-8ffd-8849e85aa43a');
  if (carDeliveryDates) {
    const carDeliveryDatesIndex = movingDatesSection.dates.find(d => d.hhgMovingDatesCategoryId === 'd7772ae7-8ebc-4580-8ffd-8849e85aa43a');
    carDeliveryDates.estimatedStartDate = safeDate(flatMovingDates.estimatedCarDeliveryStart);
    carDeliveryDates.estimatedEndDate = safeDate(flatMovingDates.estimatedCarDeliveryEnd);
    carDeliveryDates.actualStartDate = safeDate(flatMovingDates.actualCarDeliveryStart);
    carDeliveryDates.actualEndDate = safeDate(flatMovingDates.actualCarDeliveryEnd);
    movingDatesSection.dates[carDeliveryDatesIndex] = carDeliveryDates;
  } else {
    movingDatesSection.dates.push({
      hhgMovingDatesId: movingDatesSection.info.hhgMovingDateId,
      hhgMovingDatesCategoryId: 'd7772ae7-8ebc-4580-8ffd-8849e85aa43a',
      estimatedStartDate: safeDate(flatMovingDates.estimatedCarDeliveryStart),
      estimatedEndDate: safeDate(flatMovingDates.estimatedCarDeliveryEnd),
      actualStartDate: safeDate(flatMovingDates.actualCarDeliveryStart),
      actualEndDate: safeDate(flatMovingDates.actualCarDeliveryEnd)
    });
  }

  let storageDates = movingDatesSection.dates.find(d => d.hhgMovingDatesCategoryId === '6517f1c0-de3c-4d5a-a642-0245ac6f5ae2');
  if (storageDates) {
    const storageDatesIndex = movingDatesSection.dates.find(d => d.hhgMovingDatesCategoryId === '6517f1c0-de3c-4d5a-a642-0245ac6f5ae2');
    storageDates.estimatedStartDate = safeDate(flatMovingDates.estimatedStorageStart);
    storageDates.estimatedEndDate = safeDate(flatMovingDates.estimatedStorageEnd);
    storageDates.actualStartDate = safeDate(flatMovingDates.actualStorageStart);
    storageDates.actualEndDate = safeDate(flatMovingDates.actualStorageEnd);
    movingDatesSection.dates[storageDatesIndex] = storageDates;
  } else {
    movingDatesSection.dates.push({
      hhgMovingDatesId: movingDatesSection.info.hhgMovingDateId,
      hhgMovingDatesCategoryId: '6517f1c0-de3c-4d5a-a642-0245ac6f5ae2',
      estimatedStartDate: safeDate(flatMovingDates.estimatedStorageStart),
      estimatedEndDate: safeDate(flatMovingDates.estimatedStorageEnd),
      actualStartDate: safeDate(flatMovingDates.actualStorageStart),
      actualEndDate: safeDate(flatMovingDates.actualStorageEnd)
    });
  }

  movingDates[movingDatesSectionIndex] = movingDatesSection;

  return movingDates;
};
